// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-companyOverview":"jobSearchDetail-companyOverview","jobSearchDetail-companyOverview__link":"jobSearchDetail-companyOverview__link"};